import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './DiscoveryDashboard.css';

function DiscoveryDashboard() {
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const fetchSessions = async () => {
      const res = await axios.get('https://api.discovery.quantecsystems.com/sessions');
      setSessions(res.data);
    };
    fetchSessions();
  }, []);

  return (
    <div className="dashboard-container">
      <h2>Discovery Call Dashboard</h2>
      <table>
        <thead>
          <tr>
            <th>Company</th>
            <th>Session ID</th>
            <th>Date</th>
            <th>Answers</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map(session => (
            <tr key={session.sessionId}>
              <td>{session.companyName || session.companyId}</td>
              <td>{session.sessionId}</td>
              <td>{new Date(session.timestamp).toLocaleString()}</td>
              <td>{session.answerCount || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DiscoveryDashboard;
